import styled from '@emotion/styled';
import { Accordion, AccordionSummary } from '@mui/material';

export const StyledAccordion = styled(Accordion)`
  border: 1px solid var(--grey-gr-200);
  border-bottom: 0;

  &:before {
    display: none;
  }

  &.Mui-expanded {
    margin: 0;
  }

  &:first-of-type {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-of-type {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border-bottom: 1px solid var(--grey-gr-200);
  }
`;

export const StyledAccordionSummary = styled(AccordionSummary)`
  min-height: 64px;
  padding: 20px 16px;

  .MuiTypography-root {
    font-size: 16px;
    font-weight: 500;
  }

  .MuiAccordionSummary-content {
    margin: 0;
  }

  .MuiAccordionSummary-content.Mui-expanded {
    margin: 0;
  }
`;
